import APIClient from '@/shared/http/clients/api'

const resourceName = 'ChecklistSupervisao'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)
const GetEnum = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/enum`, data, config)

const cheacklistsurveyRepository = {
  GetAll,
  GetEnum
}
export default cheacklistsurveyRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/cheacklistsurvey.js